class TasteWheel {
  /**
   * @param {Node} container
   */
  constructor(container, scrollToEl) {
    this.Draggable = window.app.draggable
    this.container = container
    this.scrollToEl = scrollToEl
    this.userDragged = false
    this.init()
  }

  init() {
    const shot = this.container.getElementsByClassName('taste-wheel__shot')[0]
    const shotHandle = new this.Draggable(shot, {
      type: 'x,y',
      edgeResistance: 0.8,
      bounds: this.container,
      onPress: () => {
        this.container.classList.add('is-pressed')
      },
      onRelease: () => {
        this.container.classList.remove('is-pressed')

        if (!this.userDragged) return

        this.container.classList.add('was-used')

        const { angle, distance } = this.getDistanceAndAngle(shotHandle.x, shotHandle.y)
        const tastes = this.getTastes(angle, distance)

        if (typeof this.onPick === 'function') this.onPick(tastes)
        setTimeout(() => {
          if (this.scrollToEl) this.scrollToEl.scrollIntoView({ behavior: 'smooth' })
        }, 1000)
      },
      onDrag: () => {
        this.userDragged = true
      }
    })
  }

  getDistanceAndAngle(x, y) {
    const distance = 100 * Math.hypot(x, y) / this.container.clientHeight
    let angle = Math.atan(y / x) * 180 / Math.PI

    if (x < 0) angle += 180
    else if (y < 0) angle += 360

    return { angle, distance }
  }

  getTastes(angle, distance) {
    if (distance < 7) {
      return { sweet: 33, bitter: 33, sour: 33 }
    }

    // Sweet percentage
    let sweet = Math.round( 100 * (angle - 90) / 120 )
    if (sweet > 100) sweet = 200 - sweet
    sweet = Math.max(sweet, 0)

    // Bitter percentage
    const bitterAdjustedAngle = angle > 240 ? angle - 360 : angle
    let bitter = Math.round( 100 * (bitterAdjustedAngle + 30) / 120 )
    if (bitter > 100) bitter = 200 - bitter
    bitter = Math.max(bitter, 0)

    // Sour percentage
    const sourAdjustedAngle = angle < 120 ? 360 + angle : angle
    let sour = Math.round( 100 * (sourAdjustedAngle - 210) / 120 )
    if (sour > 100) sour = 200 - sour
    sour = Math.max(sour, 0)

    return { sweet, bitter, sour }
  }
}

const tasteWheels = document.getElementsByClassName('taste-wheel')
const cocktailList = document.getElementsByClassName('cocktail-list')[0]

for (const el of tasteWheels) {
  const tasteWheel = new TasteWheel(el, cocktailList.parentElement)
  tasteWheel.onPick = tastes => { cocktailList.dispatchEvent(new CustomEvent('filter', { detail: tastes })) }
}
